<template>
    <div class="mvt-faq">
        <mvtCollapse v-for="(faq, index) in faqs" :key="index" :disable="disableCollapse">
            <template v-slot:header="collapsible">
                <div class="faq-q" :[getDataNoSnippetAttr]="true">
                    <component :is="questionTag">{{faq.question}}</component>
                </div>
            </template>
            <template v-slot:default>
                <div class="faq-a" :[getDataNoSnippetAttr]="true" v-html="faq.answer">
                </div>
            </template>
        </mvtCollapse>

        <Schema v-if="faqSchema" :text="faqSchema"></Schema>
    </div>
</template>
<script src="./mvt-faq.js"></script>

<style lang="scss">
@use "./mvt-faq.scss" as *;
</style>